import { Button, Card, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faPlus, faSave, faTimes, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import {
    setManifesto, setEstados, setSelectMunicipios,
    gravarErrors, clearManifesto, loadManifesto,
    setSelectMunicipiosCarregamento, clearCTe,
    clearError, loadMunicipiosDescargaSelect,
    removeListaMunicipioDescarregamentoTodos

} from "../../../features/manifestoSlice";
import auxService from "../../../services/AuxService";
import MunicipioCarrega from "./MunicipioCarrega";
import UfPercurso from "./UfPercurso";
import manifestoService from "../../../services/ManifestoService";
import { CamposObrigatorios, MakeMessageError } from "../../../components/Components";
import { useNavigate, useParams } from "react-router-dom";
import AutorizacaoDownload from "../autorizacao_download/AutorizacaoDownload";
import ProdutoPredominante from "../produto_predominante/ProdutoPredominante";
import { tratarErrors } from "../../../utils/utils";
import InfoManifesto from "../inf_adicionais/InfoManifesto";
import LacresManifesto from "../lacre_manifesto/LacresManifesto";
import InfDocumentos from "../inf_documento/InfDocumentos";
import Rodoviario from "../modal_rodoviario/Rodoviario";
import Seguro from "../inf_seguro/Seguro";
import ModalFormAereo from "../modal_aereo/ModalAereo";
import Trem from "../modal_ferroviario/Trem";
import ModalAquaticoForm from "../modal_aquatico/ModalAquatico";
import { TypeModal, TypeEmitente, TypeTransporte } from "../../../lists";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useToast } from "../../../components/Toast/useToast";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

export default function FormManifesto() {
    const { alertModal, ModalMessageEl } = useModalMessage();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('principal');
    const formManifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const selectEstados = useSelector((state: RootState) => state.manifesto.selectEstados);
    const listaUfPercurso = useSelector((state: RootState) => state.manifesto.manifesto.infPercurso);
    const listaMunicipiosCarregamento = useSelector((state: RootState) => state.manifesto.manifesto.infMunCarrega);
    const listaMunicipiosDescarregamento = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const estadoInicialRef = useRef<HTMLSelectElement>(null);
    const [showProdutoPredominante, setShowProdutoPredominante] = useState(false);
    const [showDocumentoManifesto, setShowDocumentoManifesto] = useState(false);
    const [showDocumentoConhecimento, setShowDocumentoConhecimento] = useState(false);
    const dhiniviagemRef = useRef<HTMLInputElement>(null);
    const tipoEmitenteRef = useRef<HTMLSelectElement>(null);
    const modalRef = useRef<HTMLSelectElement>(null);
    const ufFimRef = useRef<HTMLSelectElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { showToast, ToastContainerEl } = useToast("bottom-end");
    const btnSalvarRef = useRef<HTMLButtonElement>(null);
    const numeroRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const handleChangeChecked = (e: any) => {
        const { name, _, checked } = e.target;
        if (checked) {

            if (formManifesto.infMunCarrega.length > 1) {
                alertModal(
                    'Ind. Carrega. Posterior somente pode ser marcado se houve somente um município de carregamento.'
                );
                return;
            }

            if (formManifesto.ufini !== formManifesto.uffim) {
                alertModal('Somente é permitido Ind. Carregmento Posterior na mesma UF');
                return;
            }

            if (tipoEmitenteRef.current) {
                dispatch(setManifesto({ [tipoEmitenteRef.current.name]: '2' }));
                tipoEmitenteRef.current.setAttribute('disabled', 'disabled');
            }

            if (modalRef.current) {
                dispatch(setManifesto({ [modalRef.current.name]: '1' }));
                modalRef.current.setAttribute('disabled', 'disabled');
            }
            setShowDocumentoManifesto(false);
            setShowDocumentoConhecimento(false);

            dispatch(removeListaMunicipioDescarregamentoTodos())
        } else {
            if (tipoEmitenteRef.current) {
                tipoEmitenteRef.current.removeAttribute('disabled');
            }

            if (modalRef.current) {
                modalRef.current.removeAttribute('disabled');
            }
        }


        dispatch(setManifesto({ [name]: checked }));
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        dispatch(setManifesto({ [name]: value }));


        dispatch(clearError(name))

        if (name === 'tpemit') {
            if (value === '1') {
                setShowProdutoPredominante(true);
                setShowDocumentoConhecimento(true);

            } else {
                setShowProdutoPredominante(false);
                setShowDocumentoConhecimento(false);
                dispatch(clearCTe());
            }
        }

        if (name === 'modal') {

            if (value === '3') {
                if ((formManifesto.ufini === 'AM' && formManifesto.uffim === 'AM') ||
                    (formManifesto.ufini === 'AP' && formManifesto.uffim === 'AP')
                ) {

                    setShowDocumentoManifesto(true);
                } else {
                    setShowDocumentoManifesto(false);
                }
            } else {
                setShowDocumentoManifesto(false);
            }
        }
    }

    const handleChangeEstadoInicial = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        dispatch(setManifesto({ [name]: value }));

        if (value !== '') {
            auxService.getMunicipiosByUf(value).then(data => {
                dispatch(setSelectMunicipios(data));
            })
                .catch(error => console.error(error));
        } else {
            dispatch(setSelectMunicipios([
                {
                    id: 0,
                    name: 'Selecione uma UF Inicial',
                    estado: {
                        uf: ''
                    },
                    capital: 0,
                    cod_ibge: 0,
                }
            ]))
        }


        if (name === 'ufini') {
            if (formManifesto.modal.toString() === '3') {
                if ((value === 'AM' && formManifesto.uffim === 'AM') ||
                    (value === 'AP' && formManifesto.uffim === 'AP')
                ) {
                    setShowDocumentoManifesto(true);
                } else {
                    setShowDocumentoManifesto(false);
                }
            }
        }

    }

    const handleChangeEstadoFinal = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        if (value === "") {
            dispatch(setManifesto({ [name]: "" }));
            dispatch(setSelectMunicipiosCarregamento([]));
        } else {
            dispatch(setManifesto({ [name]: value }));
            auxService.getMunicipiosByUf(value).then(res => {
                dispatch(setSelectMunicipiosCarregamento(res));
            })
        }

        if (name === 'uffim') {
            if (formManifesto.modal.toString() === '3') {
                if ((value === 'AM' && formManifesto.ufini === 'AM') ||
                    (value === 'AP' && formManifesto.ufini === 'AP')
                ) {
                    setShowDocumentoManifesto(true);
                } else {
                    setShowDocumentoManifesto(false);
                }
            }
        }
    }

    const direcionaTab = (data: any) => {
        Object.keys(data).some(item => {
            if (item.split('.')[0].includes('modal_aquatico')) {
                setActiveTab('aquatico');
                return false;
            }
            else if (item.split('.')[0].includes('modal_rodoviario')) {
                setActiveTab('rodoviario');
                return false;
            }
            else if (item.split('.')[0].includes('modal_aereo')) {
                setActiveTab('aereo');
                return false;
            }
            else if (item.split('.')[0].includes('modal_ferroviario')) {
                setActiveTab('ferroviario');
                return false;
            }
            else if (item.split('.')[0].includes('infMunDescarga')) {
                setActiveTab('inf_documentos');
                return false;
            }
            else if (item.split('.')[0].includes('seg')) {
                setActiveTab('inf_seguro');
                return false;
            }
            else if (item.split('.')[0].includes('prodPred')) {
                setActiveTab('produto_predominante');
                return false;
            }
            else {
                setActiveTab('principal');
                return true
            }
        });
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();


        const listaErrors = [
            'prodPred',
            'modal_rodoviario',
            'modal_aereo',
            'modal_ferroviario',
            'modal_aquatico',
            'modal_ferroviario.trem'
        ];
        if (id === undefined) {
            try {
                btnSalvarRef.current?.setAttribute('disabled', 'disabled');
                numeroRef.current?.setAttribute('disabled', 'disabled');
                await manifestoService.create(formManifesto).then(res => {
                    dispatch(clearManifesto());
                    navigate('/manifesto');
                })
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 422) {
                        const newerrors: Record<string, any> = tratarErrors(error.response.data, listaErrors);
                        dispatch(gravarErrors({ ...newerrors }))
                        showToast(
                            Object.keys(newerrors).length > 0 ?
                                newerrors[Object.keys(newerrors)[0]][0] :
                                'Houve erro ao gravar. Verifique o formulário.'
                            , { variant: 'danger' });

                        direcionaTab(error.response.data)
                    } else {
                        showToast(
                            error.response.data.message, { variant: 'danger' }
                        )
                    }
                }
                btnSalvarRef.current?.removeAttribute('disabled');
                numeroRef.current?.removeAttribute('disabled');
            }
            btnSalvarRef.current?.removeAttribute('disabled');
            numeroRef.current?.removeAttribute('disabled');

        } else {

            try {
                btnSalvarRef.current?.setAttribute('disabled', 'disabled');
                numeroRef.current?.setAttribute('disabled', 'disabled');
                await manifestoService.update(id, formManifesto).then(res => {
                    dispatch(clearManifesto());
                    navigate('/manifesto');
                })
            } catch (error: any) {

                if (error.response) {
                    if (error.response.status === 422) {
                        const newerrors: Record<string, any> = tratarErrors(error.response.data, listaErrors);
                        dispatch(gravarErrors({ ...newerrors }))
                        showToast(
                            Object.keys(newerrors).length > 0 ?
                                newerrors[Object.keys(newerrors)[0]][0] :
                                'Houve erro ao gravar. Verifique o formulário.',
                            { variant: 'danger' }
                        );
                        direcionaTab(error.response.data);

                    } else {
                        showToast(
                            error.response.data.message, { variant: 'danger' }
                        )
                    }
                }
                btnSalvarRef.current?.removeAttribute('disabled');
                numeroRef.current?.removeAttribute('disabled');
            }
            btnSalvarRef.current?.removeAttribute('disabled');
            numeroRef.current?.removeAttribute('disabled');
        }

    }

    useEffect(() => {

        async function loadData() {
            dispatch(clearManifesto());
            await auxService.getEstados().then((estados) => {
                dispatch(setEstados(estados));
            }
            );

            if (!id) {

                if (formManifesto.ufini !== "") {
                    await auxService.getMunicipiosByUf(formManifesto.ufini).then(data => {
                        dispatch(setSelectMunicipios(data));
                    }).catch(error => console.error(error));
                }

                if (formManifesto.uffim !== "") {
                    await auxService.getMunicipiosByUf(formManifesto.uffim).then(data => {
                        dispatch(setSelectMunicipiosCarregamento(data));
                    }).catch(error => console.error(error));
                }

                await auxService.getNextNumManifesto().then(res => {
                    dispatch(setManifesto({ nmdf: res.numero }));
                }).catch(error => console.log(error));



            } else {
                await manifestoService.get(id).then(data => {
                    dispatch(loadManifesto(data));

                    if (data.tpemit === 1) {
                        setShowProdutoPredominante(true);
                        setShowDocumentoConhecimento(true);
                    }

                    if (data.modal === 3) {
                        if ((data.ufini === 'AM' && data.uffim === 'AM') ||
                            (data.ufini === 'AP' && data.uffim === 'AP')
                        ) {

                            setShowDocumentoManifesto(true);
                        } else {
                            setShowDocumentoManifesto(false);
                        }
                    }

                    auxService.getMunicipiosByUf(data.ufini).then(data => {
                        dispatch(setSelectMunicipios(data));
                    }).catch(error => console.error(error));

                    auxService.getMunicipiosByUf(data.uffim).then(data => {
                        dispatch(setSelectMunicipiosCarregamento(data));
                    }).catch(error => console.error(error));

                    dispatch(loadMunicipiosDescargaSelect())
                }).catch(error => console.error(error))
            }
            btnSalvarRef.current?.removeAttribute('disabled');
            numeroRef.current?.removeAttribute('disabled');
        }


        loadData();

        return () => {
            dispatch(clearManifesto());
        }
    }, [])

    const disabledUFFinal = () => {
        const disabled = listaUfPercurso?.length > 0 ||
            listaMunicipiosDescarregamento?.length > 0 ||
            formManifesto.indcarregaposterior === true
        return disabled;
    }
    const disabledUFInicial = () => {
        return listaMunicipiosCarregamento?.length > 0 || formManifesto.indcarregaposterior === true
    }

    const disabledCamposIndCarregaPosteriorChecked = () => {
        return formManifesto.indcarregaposterior;
    }

    const handleCancelar = async () => {
        
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Cancelar a digitação ?</>,
            btnConfirmOptions: {
                title: 'Sim',
                icon: faCheckCircle,
                variant: 'success'
            },
            btnCancelOptions: {
                title: 'Não',
                icon: faXmarkCircle,
                variant: 'danger'
            }
        })

        if (confirmed) {
            navigate('/manifesto')
        }
    }

    return (<>
        <Form onSubmit={handleSubmit} noValidate>
            <Card className="card-success card-outline">
                <Card.Header className="">
                    <Button type="submit" variant={id ? 'success' : 'primary'}
                        className="me-2 " id="btn-salvar" ref={btnSalvarRef} disabled>
                        <FontAwesomeIcon icon={id ? faSave : faPlus} /> {id ? 'Salvar' : 'Criar'}
                    </Button>
                    <Button type="button" variant="danger" id="btn-cancelar" title="ESC para cancelar"
                        onClick={handleCancelar}>
                        <FontAwesomeIcon icon={faTimes} /> Cancelar
                    </Button>
                </Card.Header>

                <Card.Body className="p-2">
                    <Tabs defaultActiveKey="principal"
                        activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'principal')}
                        id="tab-example" className="mb-2"
                    >
                        <Tab eventKey="principal" title="Principal" className="px-1">
                            <Card className="card-primary card-outline mb-2">
                                <Card.Body>
                                    <Row className=" g-2 mb-3">
                                        <Col md={'1'}>
                                            <Form.Group className="mb-2" controlId="nmdf">
                                                <Form.Label>* Número</Form.Label>
                                                <Form.Control type="text" name="nmdf" value={formManifesto.nmdf}
                                                    ref={numeroRef} disabled
                                                    maxLength={9}
                                                    className={`${errors.nmdf?.length > 0 ? "is-invalid" : ""}`}
                                                    onChange={handleChange} autoFocus />
                                                <MakeMessageError errors={errors} field="nmdf" />
                                            </Form.Group>
                                        </Col>

                                        <Col md={'1'}>
                                            <Form.Group className="mb-2" controlId="ufini">
                                                <Form.Label>* UF Inicial</Form.Label>
                                                <Form.Select name="ufini" value={formManifesto.ufini}
                                                    onChange={handleChangeEstadoInicial}
                                                    ref={estadoInicialRef} disabled={disabledUFInicial()}>
                                                    {selectEstados?.map((estado) => (
                                                        <option key={estado.id} value={estado.uf}>
                                                            {estado.uf === "" ? estado.name : estado.uf}
                                                        </option>
                                                    )
                                                    )}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="ufini" />
                                            </Form.Group>
                                        </Col>

                                        <Col md={'1'}>
                                            <Form.Group className="mb-2" controlId="uffim">
                                                <Form.Label>* UF Final</Form.Label>
                                                <Form.Select name="uffim" value={formManifesto.uffim}
                                                    ref={ufFimRef}
                                                    onChange={handleChangeEstadoFinal} disabled={disabledUFFinal()}>
                                                    {selectEstados?.map((estado: any) => {
                                                        return (
                                                            <option
                                                                key={estado.id}
                                                                value={estado.uf}>
                                                                {estado.uf === "" ? estado.name : estado.uf}
                                                            </option>
                                                        )
                                                    })}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="uffim" />
                                            </Form.Group>
                                        </Col>

                                        <Col md>
                                            <Form.Group className="mb-2" controlId="tpemit">
                                                <Form.Label>* Tipo Emitente</Form.Label>
                                                <Form.Select name="tpemit" value={formManifesto.tpemit}
                                                    ref={tipoEmitenteRef}
                                                    disabled={disabledCamposIndCarregaPosteriorChecked()}
                                                    onChange={handleChange} >
                                                    {TypeEmitente.map((x) => (
                                                        <option key={x.id} value={x.id}>{x.name}</option>
                                                    ))}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="tpemit" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group className="mb-2" controlId="tptransp">
                                                <Form.Label>* Tipo Transportador</Form.Label>
                                                <Form.Select name="tptransp" value={formManifesto.tptransp}
                                                    onChange={handleChange} >
                                                    {TypeTransporte.map((x) => (
                                                        <option key={x.id} value={x.id} >{x.name}</option>
                                                    ))}
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="tptransp" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group className="mb-2" controlId="modal">
                                                <Form.Label>* Modal</Form.Label>
                                                <Form.Select name="modal" value={formManifesto.modal}
                                                    ref={modalRef}
                                                    disabled={disabledCamposIndCarregaPosteriorChecked()}
                                                    onChange={handleChange} >
                                                    {TypeModal.map((x) => (
                                                        <option key={x.id} value={x.id}>{x.name}</option>
                                                    ))}

                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="modal" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={'2'}>
                                            <Form.Group className="mb-2" controlId="dhiniviagem">
                                                <Form.Label>Dt. Hr. Inicio Viagem</Form.Label>
                                                <Form.Control type="datetime-local" name="dhiniviagem"
                                                    ref={dhiniviagemRef}
                                                    value={formManifesto.dhiniviagem}
                                                    onChange={handleChange} />
                                                <MakeMessageError errors={errors} field="nmdf" />

                                            </Form.Group>
                                        </Col>


                                    </Row>

                                    <Row className="g-2 mb-3">

                                        <Col md>
                                            <Form.Group className="mb-2" controlId="vcarga">
                                                <Form.Label className="text-danger">* Valor total da mercadoria:</Form.Label>
                                                <Form.Control type="number" name="vcarga" value={formManifesto.vcarga}
                                                    className={`${errors.vcarga?.length > 0 ? "is-invalid" : ""}`}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;

                                                        dispatch(setManifesto({
                                                            [name]: value.replace(/[^0-9.]/g, "")
                                                                .replace(/^(\d{0,13})\d*/, "$1")
                                                                .replace(/(\.\d{2})\d+/, "$1")
                                                        }));
                                                        dispatch(clearError(name))

                                                    }}
                                                />
                                                <MakeMessageError errors={errors} field="vcarga" />
                                            </Form.Group>
                                        </Col>


                                        <Col md>
                                            <Form.Group controlId="cunid">
                                                <Form.Label>* Unidade do Peso Bruto:</Form.Label>

                                                <Form.Select name="cunid" value={formManifesto.cunid}
                                                    className={`${errors.cunid?.length > 0 ? "is-invalid" : ""}`}
                                                    onChange={handleChange}>
                                                    <option key="01" value="01">KG</option>
                                                    <option key="02" value="02">TON</option>
                                                </Form.Select>
                                                <MakeMessageError errors={errors} field="cunid" />
                                            </Form.Group>
                                        </Col>

                                        <Col md>
                                            <Form.Group controlId="qcarga">
                                                <Form.Label className="text-danger">* Peso Bruto total:</Form.Label>
                                                <Form.Control type="number" name="qcarga" value={formManifesto.qcarga}
                                                    className={`${errors.qcarga?.length > 0 ? "is-invalid" : ""}`}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;

                                                        dispatch(setManifesto({
                                                            [name]: value.replace(/[^0-9.]/g, "")
                                                                .replace(/^(\d{0,11})\d*/, "$1")
                                                                .replace(/(\.\d{4})\d+/, "$1")
                                                        }));
                                                        dispatch(clearError(name))

                                                    }}
                                                />
                                                <MakeMessageError errors={errors} field="qcarga" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={'auto'} className="d-flex align-items-end justify-content-center mb-2">
                                            <Form.Group controlId="indcarregaposterior">
                                                <Form.Switch className="mb-0" type="switch" name="indcarregaposterior"
                                                    label="Ind. Carrega. Posterior?"
                                                    title={`Indicador de MDFe com inclusão da Carga posterior a emissão 
                                                                    por evento de inclusão de DF-e`}
                                                    checked={formManifesto.indcarregaposterior}
                                                    onChange={handleChangeChecked} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={'auto'} className="d-flex align-items-end justify-content-center mb-2">
                                            <Form.Group controlId="indcanalverde">
                                                <Form.Switch className="mb-0" type="switch" name="indcanalverde"
                                                    label="Ind. Canal Verde?"
                                                    title="Indicador de participação do Canal Verde?"
                                                    checked={formManifesto.indcanalverde}
                                                    onChange={handleChangeChecked} />
                                            </Form.Group>
                                        </Col>

                                    </Row>

                                    <Row className="g-2">
                                        <Col md>
                                            <MunicipioCarrega estadoInicialRef={estadoInicialRef} />
                                        </Col>
                                        <Col md>
                                            <UfPercurso />
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>

                        </Tab>

                        {formManifesto.modal.toString() === '1' && (
                            <Tab eventKey="rodoviario" title="Rodoviário" >
                                <Rodoviario />
                            </Tab>
                        )}

                        {formManifesto.modal.toString() === '2' && (
                            <Tab eventKey="aereo" title="Aéreo">
                                <ModalFormAereo />
                            </Tab>
                        )}

                        {formManifesto.modal.toString() === '3' && (
                            <Tab eventKey="aquatico" title="Aquaviário">
                                <ModalAquaticoForm />
                            </Tab>
                        )}

                        {formManifesto.modal.toString() === '4' && (
                            <Tab eventKey="ferroviario" title="Ferroviário">
                                <Trem />
                            </Tab>
                        )}

                        <Tab eventKey="inf_documentos" title="Inf. Documentos">
                            <InfDocumentos
                                showDocumentoConhecimento={showDocumentoConhecimento}
                                showDocumentoManifesto={showDocumentoManifesto}
                            />
                        </Tab>

                        <Tab eventKey="inf_seguro" title="Inf. Seguros" className="px-1">
                            <Seguro />
                        </Tab>

                        <Tab eventKey="inf_adicionais" title="Informações Adicionais">
                            <InfoManifesto handleChange={handleChange} />
                        </Tab>

                        <Tab eventKey="manifesto_lacre" title="Lacres do manifesto">
                            <LacresManifesto />
                        </Tab>

                        <Tab eventKey="autorizacao_download" title="Autorização Download">
                            <AutorizacaoDownload />
                        </Tab>

                        {showProdutoPredominante && (
                            <Tab eventKey="produto_predominante" title="Produto Predominante">
                                <ProdutoPredominante />
                            </Tab>
                        )}
                    </Tabs>

                </Card.Body>
                <Card.Footer >
                    <CamposObrigatorios />
                </Card.Footer>
            </Card>
        </Form>
        {ConfirmModal}
        {ModalMessageEl}
        {ToastContainerEl}
    </>)
}